import React from "react";
import { Grid, CardContent, CardHeader, Card, Divider, Fab } from "@material-ui/core";
import TradesTable from "./TradesTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { useTradesData } from "../../../data/trading/trades/hooks/useTradesData";
import { useTradeIndex } from "../../../data/trading/trades/hooks/useTradesIndex";
import { TradesFilterButton } from "./TradesFilter";
import { PageDataStatus } from "../../../data/models";
import { useNotificationHandler } from "../../../core/notifications/hooks";

const TradesPage: PageComponent = ({ userAccessRights }) => {
	const pageStyles = usePageStyles();

	const [pageData, dispatchLoadTradesPage, invalidateData] = useTradesData();
	const [pageIndex, dispatchSetIndex] = useTradeIndex();

	React.useEffect(() => {
		if (pageData && pageData.status === PageDataStatus.DataInvalidated) {
			dispatchLoadTradesPage();
		}
	}, [dispatchLoadTradesPage, pageData]);

	React.useEffect(() => () => { invalidateData() }, [])

	useNotificationHandler<string>(
		"TradeChange",
		e => {
			console.log("TradeChange", e);
			invalidateData();
		},
		[]
	);

	return (
		<>
			<Grid container className={pageStyles.root}>
				<Grid item xs={12} className={pageStyles.gridItem}>
					<Card>
						<CardHeader
							title={<PageTitle title="tradeTitle" />}
							action={<TradesFilterButton />}
						/>
						<Divider />
						<CardContent>
							<TradesTable
								pageIndex={pageIndex}
								pageData={pageData}
								onPageIndexChange={dispatchSetIndex}
								userAccessRights={userAccessRights}
								getData={dispatchLoadTradesPage}
							/>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</>
	);
};

export default TradesPage;
